<template>
  <div>
    <van-nav-bar
      title="完善账户资料"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-field
      label="姓名"
      v-model="userInfo.username"
    />
    <van-field
      label="身份证号码"
      v-model="userInfo.idCard"
    />
    <van-field
      label="银行卡号"

      v-model="userInfo.bankNo"
    />
    <van-field
      label="联系电话"
      v-model="userInfo.mobile"

    />
    <van-field
      v-model="userInfo.code"
      label-class="label-class"
      type="number"
      label="验 证 码"
    >
      <template #button>
        <van-button slot="button" size="small" @click="sendVerifySms" v-if="codeSended == false"
                    type="info">获取验证码
        </van-button>
        <van-button slot="button" size="small" disabled v-else type="info">{{codeSendBtntext}}
        </van-button>
      </template>
    </van-field>
    <div class="uploadbox">
      <div class="title">上传身份证正面(身份证头像面)</div>
      <van-uploader :before-read="beforeRead" :max-count="1" v-model="fileList['idCardImg1']" :after-read="afterReadID1">

      </van-uploader>
    </div>
    <div class="uploadbox">
      <div class="title">上传身份证反面(身份证国徽面)</div>
      <van-uploader v-model="fileList['idCardImg2']" :max-count="1" :before-read="beforeRead" :after-read="afterReadID2">

      </van-uploader>
    </div>
    <div class="uploadbox">
      <div class="title">上传银行卡正面(带卡号面)</div>
      <van-uploader v-model="fileList['bankImg']" :max-count="1" :before-read="beforeRead":after-read="afterReadBank">

      </van-uploader>
    </div>
    <!-- <van-field
       v-model="userInfo.city"
       label-class="label-class"
       type="text"
       @click="showArea=true"
       readonly
       label="选择地区"
     />
     <van-field
       label="详细地址"
       v-model="userInfo.address"
       type="textarea"
     />-->
    <div style="margin: 16px;">
      <van-button round block type="info" @click="onSubmit">
        提交
      </van-button>
    </div>

    <van-popup position="bottom" v-model="showArea">
      <van-area title="请选择" @cancel="showArea=false" @confirm="checkAddress" :area-list="areaList" />
    </van-popup>
  </div>
</template>

<script>
  import { areaList } from '@vant/area-data';
  import * as imageConversion from 'image-conversion'
  export default {
    data() {
      return {
        showArea:false,
        areaList,
        show: false,
        userInfo: {},
        codeSended: false,
        codeSendBtntext: '',
        posting:false,
        scope:[],
        fileList:{
          idCardImg1:[],
          idCardImg2:[],
          bankImg:[]
        }
      };
    },
    methods: {
      beforeRead(file) {
        if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
          Toast('请上传 jpg/png 格式图片');
          return false;
        }
        return true;
      },
      afterReadID1(file){
        this.uploadimg(file,'idCardImg1');

      },
      afterReadID2(file){
        this.uploadimg(file,'idCardImg2');
      },
      afterReadBank(file){
        this.uploadimg(file,'bankImg');
      },
      uploadimg(file,key){
        this.fileList[key] = [
          {
            url:file.content,
            isImage:true,
            status:'uploading'
          }
        ]
        this.$toast.loading("上传中")
        imageConversion.compressAccurately(file.file, 1536).then(blob => {
          let uploadfile = new window.File([blob], file.file.name, file)
          this.uploadFile("/file/uploadLeshuaImage",uploadfile).then(res=>{
            this.$toast.clear()
            if(res.code){
              this.userInfo[key] = res.data
            }else{
              this.$toast(res.msg)
            }
          }).catch(err=>{console.log(err)})
        });
      },
      checkAddress(arr){
        if(arr && arr.length==3){
          this.userInfo.city = '';
          let select = [];
          for(let i in arr){
            select.push(arr[i].name)
          }
          this.userInfo.city = select.join(" ")
        }
        this.showArea = false
      },
      inScope(key){
        for (let i in this.scope){
          if(key == this.scope[i]){
            return true
          }
        }
        return false;
      },
      onClickLeft() {
        window.history.go(-1)
      },
      onSubmit() {
        for(let i in this.scope){
          if(!this.userInfo[this.scope[i]]){
            return this.$toast("请完善资料")
          }
        }
        if(this.posting) return false;
        this.posting = true
        this.$toast.loading("提交中")
        this.fetchDataPost("/agent/saveLeshuaInfo",this.userInfo,res=>{
          this.$toast.loading().clear()
          this.posting = false
          if(res.code){
            this.$router.back()
            this.$toast.success(res.msg)
          }else{
            this.$toast(res.msg)
          }
        })
      },
      sendVerifySms() {
        if (!this.userInfo.mobile) {
          this.$toast("账号未绑定手机号码")
          return false
        }
        if (this.codeSended == true) return false
        this.$toast.loading("发送中")
        this.fetchData("/sms/sendVerifyOperatorCode", {mobile: this.userInfo.mobile}, (res) => {
          this.$toast.loading().clear()
          if (res.code) {
            this.codeSended = true
            let i = 60
            let intval = setInterval(() => {
              if (i <= 0) {
                clearInterval(intval)
                this.codeSended = false
                this.codeSendBtntext = "获取验证码"
              } else {
                this.codeSendBtntext = "( " + i + "s )"
                i--
              }
            }, 1000)
            this.$toast.success(res.msg)
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
    },
    created: function () {
      this.fetchData('/account/info', {}, (res) => {
        if(res.data.bank_info && res.data.bank_info.id){
          this.userInfo = res.data.bank_info
        }
      })
      this.scope = this.$route.query.scope
    }
  };
</script>
<style lang="scss" scoped>
  .label-class {
    text-align: justify;
  }
  .uploadbox{
    width: 100%;
    padding: 10px 16px;
    .title{
      padding-bottom: .3rem;
      font-size: .3rem;
      color: #999988;
    }
    .preview-cover{
      width: 375px;
      height: 200px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/leshuaInfo.vue